import { Link } from 'react-router-dom';
import Breadcrumbs from '@/components/base/Breadcrumbs';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/faqs';
import { useSeo } from '@/hooks/useSeo';

const SITE_URL = 'https://q88p.top';
const groups = ['入口与访问', '内容与判断', '使用与互动'];

export default function FaqPage() {
  useSeo({
    title: '常见问题_爆料专区入口与内容判断答疑 - 爆料专区导航',
    description:
      '爆料专区常见问题解答：首页入口在哪里、网址与网页的区别、手机端访问方式、如何判断爆料真实性、如何提交线索等高频疑问一次说清。',
    keywords: '爆料专区常见问题,爆料专区入口,爆料专区网址,爆料专区怎么进,爆料专区线索投稿',
    path: '/faq',
    schema: [
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: { '@type': 'Answer', text: item.answer },
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: `${SITE_URL}/` },
          { '@type': 'ListItem', position: 2, name: '常见问题', item: `${SITE_URL}/faq` },
        ],
      },
    ],
  });

  return (
    <main className="pt-16 md:pt-20">
      <section className="bg-background-100 border-b border-background-200">
        <div className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
          <Breadcrumbs items={[{ label: '首页', path: '/' }, { label: '常见问题' }]} />
          <h1 className="font-heading mt-5 text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            常见问题解答
          </h1>
          <p className="mt-4 max-w-3xl text-sm md:text-base leading-relaxed text-foreground-600">
            我们把用户最常问的问题分成入口、判断与使用三类，逐条给出明确回答。如果这里没有解决你的疑问，可以在关于我们页面留言。
          </p>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-8 space-y-12">
            {groups.map((group) => {
              const items = faqs
                .filter((item) => item.group === group)
                .map((item) => ({ id: item.id, question: item.question, answer: item.answer }));
              return (
                <div key={group}>
                  <div className="flex items-center gap-3 mb-5">
                    <span className="w-1.5 h-6 rounded-full bg-primary-500" />
                    <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{group}</h2>
                  </div>
                  <FaqAccordion items={items} />
                </div>
              );
            })}
          </div>

          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-28 space-y-6">
              <div className="bg-background-100 rounded-lg p-6">
                <h2 className="font-heading text-base font-semibold text-foreground-950">快速导航</h2>
                <ul className="mt-4 space-y-2.5">
                  <li>
                    <Link
                      to="/guide"
                      className="flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      <i className="ri-compass-3-line text-primary-500" />
                      访问指南：四步上手
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/topics"
                      className="flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      <i className="ri-layout-grid-line text-primary-500" />
                      热门话题：按分类浏览
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className="flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      <i className="ri-mail-send-line text-primary-500" />
                      关于我们：线索投稿
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="bg-accent-50 border border-accent-200 rounded-lg p-6">
                <h2 className="font-heading text-base font-semibold text-foreground-950">还有别的疑问？</h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  把你遇到的问题通过投稿表单发给我们，编辑会挑选高频问题补充到本页。
                </p>
                <Link
                  to="/about"
                  className="mt-4 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  前往留言
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </main>
  );
}